import React from "react";
import DynamicButton from "../../../components/DynamicButton/DynamicButton";
import DynamicMultiSelect from "../../../components/DynamicMultiSelect";
import { ProfileIcon } from "../../../components/ProfileIcon/ProfileIcon";

const Step4 = ({
  state,
  errors,
  validateStep,
  handleChange,
  availableBusinessRegions = [],
  availableBusinessCountries = [],
  decrementStep,
  onRegionChange = (ids) => {},
}) => {
  return (
    <>
      <ProfileIcon
        style={{
          marginTop: "18px",
        }}
        height="60px"
        width="60px"
      />
      <p
        style={{
          color: "white",
          fontSize: "14px",
          margin: "20px 1.66667em",
          textAlign: "center",
        }}
      >
        Select your business region and country
      </p>
      <div style={{ margin: "17px 0" }}>
        <DynamicMultiSelect
          name="businessRegions"
          placeholder="Select regions"
          handleOnTagRemove={(id) => {
            let filteredRegions = state.businessRegions.filter(
              (reg) => reg !== id
            );
            let filteredCountries = availableBusinessCountries
              .filter((country) => country.regionId !== id)
              .map((c) => c.id);
            let _cs = state.businessCountries.filter((c) =>
              filteredCountries.includes(c)
            );
            handleChange("businessRegions", filteredRegions);
            handleChange("businessCountries", _cs);
            onRegionChange(filteredRegions);
          }}
          value={state.businessRegions}
          onChange={(e) => {
            if (state.businessRegions.includes(e.target.value)) {
              return;
            }
            onRegionChange([...state.businessRegions, e.target.value]);
            handleChange("businessRegions", [
              ...state.businessRegions,
              e.target.value,
            ]);
          }}
          error={errors.businessRegionsError}
          options={availableBusinessRegions}
          tags={
            availableBusinessRegions &&
            availableBusinessRegions.filter((region) =>
              state.businessRegions.includes(region.id)
            )
          }
        />
      </div>
      <div style={{ margin: "17px 0 22px 0" }}>
        <DynamicMultiSelect
          name="businessCountries"
          placeholder="Select countries"
          value={state.businessCountries}
          handleOnTagRemove={(id) => {
            let filteredCountries = state.businessCountries.filter(
              (country) => country !== id
            );
            handleChange("businessCountries", filteredCountries);
          }}
          onChange={(e) => {
            if (state.businessCountries.includes(e.target.value)) {
              return;
            }
            handleChange("businessCountries", [
              ...state.businessCountries,
              e.target.value,
            ]);
          }}
          error={errors.businessCountriesError}
          options={availableBusinessCountries}
          tags={
            availableBusinessCountries &&
            availableBusinessCountries.filter((country) =>
              state.businessCountries.includes(country.id)
            )
          }
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <DynamicButton
          style={{ marginBottom: "22px" }}
          onClick={(e) => validateStep(e)}
        >
          Continue
        </DynamicButton>
        <DynamicButton
          style={{ marginLeft: 0, backgroundColor: "#000" }}
          onClick={(e) => decrementStep(e)}
        >
          Back
        </DynamicButton>
      </div>
    </>
  );
};

export default Step4;
